import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vue2Filters from 'vue2-filters'

import VueZoomer from 'vue-zoomer'
// import 'vue-zoomer/dist/vue-zoomer.css'

import VueGoogleCharts from 'vue-google-charts'

import VueAnalytics from 'vue-analytics'

import dateFormatCustom from '@/filters/date-format-custom'

Vue.config.productionTip = false

Vue.use(VueZoomer)

Vue.use(dateFormatCustom)
Vue.use(Vue2Filters)
Vue.use(VueGoogleCharts)

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // console.log(to.fullPath)
    store.commit('setMenuSelected', to.meta.title)
  } else {
    store.commit('setMenuSelected', '')
  }

  return next()
})

Vue.use(VueAnalytics, {
  id: 'UA-166148701-1',
  router
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
